import { SystemEvent } from '@mbrtargeting/metatag-shared-types/metatag-core';
import { addCssToElement } from '@mbrtargeting/metatag-utils';
import { inject, injectionTarget } from '../../../loader/decorators/inject.js';
import { onSystemEvent } from '../../../loader/decorators/on-system-event.js';
import { ConfigResolver } from '../../../loader/essentials/config-resolver.js';

@injectionTarget()
export class CssInjector {

    @inject() private configResolver!: ConfigResolver;

    @onSystemEvent(SystemEvent.SDG_CONFIG_FILE_AVAILABLE)
    init(): void {
        const doc = window.document;
        const { css = '' } = this.configResolver.getCommonSettings();
        addCssToElement(css, doc.head);
    }
}
